var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _c(
        "v-app",
        [
          _c("nav-bar", { attrs: { isCheckout: _vm.isCheckout } }),
          _c("v-main", [_c("router-view")], 1),
          _c("app-footer", { attrs: { isCheckout: _vm.isCheckout } }),
          _c("snackbar"),
          _c("cookie", {
            attrs: { "primary-color": "#4f8800", lang: _vm.$i18n.locale }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }